module.exports = __webpack_public_path__ + "media/images/loading-5fe4039b11fa6d042519dd1d049901c9.gif";